import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/frontend/submitedPersion/index.js'), 'frontend/submitedPersion/index.js')
  resolveStoreModules(require('../store/frontend/setting/index.js'), 'frontend/setting/index.js')
  resolveStoreModules(require('../store/frontend/sealCertificate/index.js'), 'frontend/sealCertificate/index.js')
  resolveStoreModules(require('../store/frontend/seal/index.js'), 'frontend/seal/index.js')
  resolveStoreModules(require('../store/frontend/requestCompany/index.js'), 'frontend/requestCompany/index.js')
  resolveStoreModules(require('../store/frontend/projects/index.js'), 'frontend/projects/index.js')
  resolveStoreModules(require('../store/frontend/historyAddress/index.js'), 'frontend/historyAddress/index.js')
  resolveStoreModules(require('../store/frontend/digitalCertificate/index.js'), 'frontend/digitalCertificate/index.js')
  resolveStoreModules(require('../store/frontend/digital/index.js'), 'frontend/digital/index.js')
  resolveStoreModules(require('../store/frontend/configs/index.js'), 'frontend/configs/index.js')
  resolveStoreModules(require('../store/frontend/companies/index.js'), 'frontend/companies/index.js')
  resolveStoreModules(require('../store/frontend/auth/index.js'), 'frontend/auth/index.js')
  resolveStoreModules(require('../store/frontend/accounts/index.js'), 'frontend/accounts/index.js')
  resolveStoreModules(require('../store/admin/users/index.js'), 'admin/users/index.js')
  resolveStoreModules(require('../store/admin/revenues/index.js'), 'admin/revenues/index.js')
  resolveStoreModules(require('../store/admin/revenue_reports/index.js'), 'admin/revenue_reports/index.js')
  resolveStoreModules(require('../store/admin/projects/index.js'), 'admin/projects/index.js')
  resolveStoreModules(require('../store/admin/payment_confirms/index.js'), 'admin/payment_confirms/index.js')
  resolveStoreModules(require('../store/admin/need_payment/index.js'), 'admin/need_payment/index.js')
  resolveStoreModules(require('../store/admin/contacts/index.js'), 'admin/contacts/index.js')
  resolveStoreModules(require('../store/admin/companies/index.js'), 'admin/companies/index.js')
  resolveStoreModules(require('../store/admin/change-sikulix-pass/index.js'), 'admin/change-sikulix-pass/index.js')
  resolveStoreModules(require('../store/admin/auth/index.js'), 'admin/auth/index.js')
  resolveStoreModules(require('../store/admin/auth/actions.js'), 'admin/auth/actions.js')
  resolveStoreModules(require('../store/admin/auth/getters.js'), 'admin/auth/getters.js')
  resolveStoreModules(require('../store/admin/auth/mutations.js'), 'admin/auth/mutations.js')
  resolveStoreModules(require('../store/admin/auth/state.js'), 'admin/auth/state.js')
  resolveStoreModules(require('../store/admin/change-sikulix-pass/actions.js'), 'admin/change-sikulix-pass/actions.js')
  resolveStoreModules(require('../store/admin/change-sikulix-pass/getters.js'), 'admin/change-sikulix-pass/getters.js')
  resolveStoreModules(require('../store/admin/change-sikulix-pass/mutations.js'), 'admin/change-sikulix-pass/mutations.js')
  resolveStoreModules(require('../store/admin/change-sikulix-pass/state.js'), 'admin/change-sikulix-pass/state.js')
  resolveStoreModules(require('../store/admin/companies/actions.js'), 'admin/companies/actions.js')
  resolveStoreModules(require('../store/admin/companies/getters.js'), 'admin/companies/getters.js')
  resolveStoreModules(require('../store/admin/companies/mutations.js'), 'admin/companies/mutations.js')
  resolveStoreModules(require('../store/admin/companies/state.js'), 'admin/companies/state.js')
  resolveStoreModules(require('../store/admin/contacts/actions.js'), 'admin/contacts/actions.js')
  resolveStoreModules(require('../store/admin/contacts/getters.js'), 'admin/contacts/getters.js')
  resolveStoreModules(require('../store/admin/contacts/mutations.js'), 'admin/contacts/mutations.js')
  resolveStoreModules(require('../store/admin/contacts/state.js'), 'admin/contacts/state.js')
  resolveStoreModules(require('../store/admin/need_payment/actions.js'), 'admin/need_payment/actions.js')
  resolveStoreModules(require('../store/admin/payment_confirms/actions.js'), 'admin/payment_confirms/actions.js')
  resolveStoreModules(require('../store/admin/projects/actions.js'), 'admin/projects/actions.js')
  resolveStoreModules(require('../store/admin/projects/getters.js'), 'admin/projects/getters.js')
  resolveStoreModules(require('../store/admin/projects/mutations.js'), 'admin/projects/mutations.js')
  resolveStoreModules(require('../store/admin/projects/state.js'), 'admin/projects/state.js')
  resolveStoreModules(require('../store/admin/revenue_reports/actions.js'), 'admin/revenue_reports/actions.js')
  resolveStoreModules(require('../store/admin/revenues/actions.js'), 'admin/revenues/actions.js')
  resolveStoreModules(require('../store/admin/revenues/mutations.js'), 'admin/revenues/mutations.js')
  resolveStoreModules(require('../store/admin/revenues/states.js'), 'admin/revenues/states.js')
  resolveStoreModules(require('../store/admin/users/actions.js'), 'admin/users/actions.js')
  resolveStoreModules(require('../store/admin/users/getters.js'), 'admin/users/getters.js')
  resolveStoreModules(require('../store/admin/users/mutations.js'), 'admin/users/mutations.js')
  resolveStoreModules(require('../store/admin/users/state.js'), 'admin/users/state.js')
  resolveStoreModules(require('../store/frontend/accounts/actions.js'), 'frontend/accounts/actions.js')
  resolveStoreModules(require('../store/frontend/auth/actions.js'), 'frontend/auth/actions.js')
  resolveStoreModules(require('../store/frontend/auth/getters.js'), 'frontend/auth/getters.js')
  resolveStoreModules(require('../store/frontend/auth/mutations.js'), 'frontend/auth/mutations.js')
  resolveStoreModules(require('../store/frontend/auth/state.js'), 'frontend/auth/state.js')
  resolveStoreModules(require('../store/frontend/companies/actions.js'), 'frontend/companies/actions.js')
  resolveStoreModules(require('../store/frontend/companies/getters.js'), 'frontend/companies/getters.js')
  resolveStoreModules(require('../store/frontend/companies/mutations.js'), 'frontend/companies/mutations.js')
  resolveStoreModules(require('../store/frontend/companies/state.js'), 'frontend/companies/state.js')
  resolveStoreModules(require('../store/frontend/configs/actions.js'), 'frontend/configs/actions.js')
  resolveStoreModules(require('../store/frontend/configs/getters.js'), 'frontend/configs/getters.js')
  resolveStoreModules(require('../store/frontend/configs/mutations.js'), 'frontend/configs/mutations.js')
  resolveStoreModules(require('../store/frontend/configs/state.js'), 'frontend/configs/state.js')
  resolveStoreModules(require('../store/frontend/digital/actions.js'), 'frontend/digital/actions.js')
  resolveStoreModules(require('../store/frontend/digitalCertificate/actions.js'), 'frontend/digitalCertificate/actions.js')
  resolveStoreModules(require('../store/frontend/digitalCertificate/getters.js'), 'frontend/digitalCertificate/getters.js')
  resolveStoreModules(require('../store/frontend/digitalCertificate/mutations.js'), 'frontend/digitalCertificate/mutations.js')
  resolveStoreModules(require('../store/frontend/digitalCertificate/state.js'), 'frontend/digitalCertificate/state.js')
  resolveStoreModules(require('../store/frontend/historyAddress/actions.js'), 'frontend/historyAddress/actions.js')
  resolveStoreModules(require('../store/frontend/historyAddress/getters.js'), 'frontend/historyAddress/getters.js')
  resolveStoreModules(require('../store/frontend/historyAddress/mutations.js'), 'frontend/historyAddress/mutations.js')
  resolveStoreModules(require('../store/frontend/historyAddress/state.js'), 'frontend/historyAddress/state.js')
  resolveStoreModules(require('../store/frontend/projects/actions.js'), 'frontend/projects/actions.js')
  resolveStoreModules(require('../store/frontend/requestCompany/actions.js'), 'frontend/requestCompany/actions.js')
  resolveStoreModules(require('../store/frontend/requestCompany/getters.js'), 'frontend/requestCompany/getters.js')
  resolveStoreModules(require('../store/frontend/requestCompany/mutations.js'), 'frontend/requestCompany/mutations.js')
  resolveStoreModules(require('../store/frontend/requestCompany/state.js'), 'frontend/requestCompany/state.js')
  resolveStoreModules(require('../store/frontend/seal/actions.js'), 'frontend/seal/actions.js')
  resolveStoreModules(require('../store/frontend/sealCertificate/actions.js'), 'frontend/sealCertificate/actions.js')
  resolveStoreModules(require('../store/frontend/sealCertificate/getters.js'), 'frontend/sealCertificate/getters.js')
  resolveStoreModules(require('../store/frontend/sealCertificate/mutations.js'), 'frontend/sealCertificate/mutations.js')
  resolveStoreModules(require('../store/frontend/sealCertificate/state.js'), 'frontend/sealCertificate/state.js')
  resolveStoreModules(require('../store/frontend/setting/actions.js'), 'frontend/setting/actions.js')
  resolveStoreModules(require('../store/frontend/setting/getters.js'), 'frontend/setting/getters.js')
  resolveStoreModules(require('../store/frontend/setting/mutations.js'), 'frontend/setting/mutations.js')
  resolveStoreModules(require('../store/frontend/setting/state.js'), 'frontend/setting/state.js')
  resolveStoreModules(require('../store/frontend/submitedPersion/actions.js'), 'frontend/submitedPersion/actions.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
